import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';

import { withCookiesManager } from 'ggApp/utils/CookiesManager';
import { initDone } from 'ggApp/modules/init/selectors';

import TopContent from './TopContent';

const enhanced = compose(
    withCookiesManager,
    connect(
        createStructuredSelector({
            initDone,
        }),
    ),
)(TopContent);

export default enhanced;
